module.exports = __webpack_public_path__ + "img/四川天府新区兴隆幼儿园.b606e738.jpg";